import { useNavigate, useParams } from "@tanstack/react-router";
import { Flex, Spin } from "antd";

import { useEntity } from "@neu/libui";

import { FormView } from "#layouts";
import { useEntityTabsStore } from "#store";

export const SettingsRecordDetail = () => {
	const navigate = useNavigate();
	const { entityName, recordID } = useParams({ strict: false });
	const removeOpenTab = useEntityTabsStore((state) => state.removeOpenTab);
	const setActiveTab = useEntityTabsStore((state) => state.setActiveTab);
	const isCreateMode = recordID === "create";
	const [queryResult] = useEntity(
		entityName,
		isCreateMode ? "" : (recordID as string)
	);
	const { data, isLoading } = queryResult;

	const handleArchivedOrBackToList = () => {
		const tabScope = `settings-${String(entityName)}`;
		if (recordID) {
			removeOpenTab(tabScope, String(recordID));
		}
		setActiveTab(tabScope, null);
		void navigate({
			to: `/settings/${String(entityName)}` as "/",
			replace: true,
		});
	};

	return (
		<Flex vertical flex={1}>
			{isCreateMode ? (
				<FormView
					entity={entityName}
					mode="create"
					onArchived={handleArchivedOrBackToList}
				/>
			) : isLoading ? (
				<Spin size="large" />
			) : (
				<FormView
					entity={entityName}
					data={data}
					onArchived={handleArchivedOrBackToList}
				/>
			)}
		</Flex>
	);
};
